import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";

import { ApiService } from "./api.service";
import { ToastService } from "./toast.service";

import { DependentDocumentsStatusModel, DependentDocumentsStautsPayload, DependentGrid, DependentGridList } from "../models/dependent-grid";
import { Dependent } from "../models/dependent";
import { ToastType } from "../constants/toast-type";

const controllerRoute = '/mydependents';

@Injectable()
export class DependentsService {

    constructor(
        private apiService: ApiService,
        private toastService: ToastService,
    ) {
    }

    public getDependents(): Observable<DependentGridList[]> {
        return this.apiService.get(`${controllerRoute}`).pipe(
            map((response: DependentGrid) => {
                return response.dependents;
            }),
        );
    }

    public getDependent(id: number): Observable<Dependent> {
        return this.apiService.get(`${controllerRoute}/update-dependent/${id}`).pipe(
            map((response: Dependent) => {
                return response;
            }),
        );
    }

    public saveDependent(payload: Dependent): Observable<DependentGridList[]> {
        return this.apiService.put(`${controllerRoute}/update-dependent`, payload).pipe(
            map((response: DependentGrid) => {
                return response.dependents;
            }),
        );
    }

    public setAddDependent(dependent: Dependent): Observable<DependentGrid> {
        return this.apiService.post(`${controllerRoute}/add-dependent`, dependent).pipe(
            map((response: DependentGrid) => {
                this.toastService.buildToastMessage(ToastType.success, '', 'New Dependent Saved!');
                return response;
            }),
        );
    }

    public setUpdateDependent(dependent: Dependent): Observable<DependentGrid> {
        return this.apiService.put(`${controllerRoute}/update-dependent`, dependent).pipe(
            map((response: DependentGrid) => {
                this.toastService.buildToastMessage(ToastType.success, '', 'Dependent Saved!');
                return response;
            }),
        );
    }

    public getDependentDocumentsStatus(dependent: DependentDocumentsStautsPayload): Observable<DependentDocumentsStatusModel> {
        return this.apiService.post(`${controllerRoute}/dependent-member-documents`, dependent).pipe(
            map((response: DependentDocumentsStatusModel) => {
                return response;
            }),
        );
    }
}